<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <router-link :to="{ path: '/admin/book/detail/list/'+ formInfo.book_id }">
          <Button icon="ios-arrow-back" size="small" class="mr20">返回</Button>
        </router-link>
        <span
          class="ivu-page-header-title mr20"
          v-text="'添加图片'"></span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="formInfo"
            :model='formInfo'
            label-position="right"
            :label-width="120"
            :rules="ruleValidate"
            @submit.native.prevent>
        <!--   封面图-->
        <FormItem label="绘本图 (1000*750)">
          <div class="demo-upload-list" v-for="item in uploadList" :key="item.url">
            <template v-if="item.status === 'finished'">
              <img :src="item.url">
              <div class="demo-upload-list-cover">
                <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
              </div>
            </template>
            <template v-else>
              <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
            </template>
          </div>
          <Upload
            v-if="uploadList.length < 50"
            ref="uploadThumb"
            :show-upload-list="false"
            :on-success="handleSuccess"
            :format="['jpg','jpeg','png']"
            :max-size="10240"
            multiple
            :on-format-error="handleFormatError"
            :on-exceeded-size="handleMaxSize"
            :before-upload="handleBeforeUpload"
            type="drag"
            :action="serverApiPic"
            style="display: inline-block;width:100px;">
            <div style="width: 100px;height:78px;line-height: 78px;">
              <Icon type="ios-camera" size="20"></Icon>
            </div>
          </Upload>
          <Modal title="查看" v-model="visible">
            <img :src="imgUrl " v-if="visible" style="width: 100%">
          </Modal>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formInfo')" :loading="loading">
            <span v-if="!loading">提交</span>
            <span v-else>提交中...</span>
          </Button>
        </FormItem>
      </Form>
    </card>

  </div>

</template>
<style>
  .demo-upload-list {
    display: inline-block;
    width: 100px;
    height: 75px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
    margin-right: 4px;
  }

  .demo-upload-list img {
    width: 100%;
    height: 100%;
  }

  .demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .6);
  }

  .demo-upload-list:hover .demo-upload-list-cover {
    display: block;
  }

  .demo-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
</style>
<script>
  import {detailEdits2, detailInfo} from '@/api/book'
  import Setting from '@/setting'
  import ueditor from '@/components/ueditorFrom/index'

  export default {
    name: 'roomEdit',
    components: {ueditor},
    data() {
      return {
        loading: false,
        server_url: Setting.serverSrc,
        serverApiPic: Setting.serverApiPic,
        imgUrl: '',
        visible: false,
        formInfo: {
          book_id: 0,
          pic: [],
          delpics: [], // 服务器待删除的照片
        },
        uploadList: [], // 缩咯图
        ruleValidate: {}
      }
    },
    created() {
      if (this.$route.params.pid !== '0' && this.$route.params.pid) {
        this.formInfo.book_id = this.$route.params.pid
      }
      if (this.$route.params.id !== '0' && this.$route.params.id) {
        this.goodsInfoEdit(this.$route.params.id)
      }
    },
    mounted() {
    },
    methods: {
      handleView(url) {
        this.imgUrl = url
        this.visible = true
      },
      // 缩略图删除
      handleRemove(file) {
        const fileList2 = this.uploadList
        this.formInfo.delpics.push(file.url)
        this.uploadList.splice(fileList2.indexOf(file), 1)
      },
      // 缩略图
      handleSuccess(res, file) {
        let file_url = res.data.file_url
        if (file_url.substring(0, 5) === 'https') {
          file.url = file_url
        } else {
          file.url = this.server_url + file_url
        }
        this.uploadList = this.$refs.uploadThumb.fileList
      },
      handleFormatError(file) {
        this.$Message.error('文件' + file.name + '格式错误，请上传jpg或者png')
      },
      handleMaxSize(file) {
        this.$Message.error('文件' + file.name + '太大，不能大于10M')
      },
      // 缩略图
      handleBeforeUpload() {
        const check = this.uploadList.length < 50
        if (!check) {
          this.$Message.error('只能上传50张图片')
        }
        return check
      },
      handleSubmit(name) {
        if (this.uploadList.length <= 0) {
          this.$Message.error('封面图必填')
          return
        }
        this.uploadList.map((item, index) => {
          this.formInfo.pic.push(item.url)
        })
        this.loading = true
        detailEdits2(this.formInfo).then(res => {
          let msg = '添加成功'
          if (this.formInfo.id > 0) {
            msg = '编辑成功'
          }
          this.$Message.success(msg)
          if (res.code === 200) {
            setTimeout(() => {
              this.$router.push({path: '/admin/book/detail/list/' + this.formInfo.book_id})
            }, 500)
          }
        }).catch(res => {
          this.$Message.error(res.msg)
          this.loading = false
        })
  },
  // 编辑加载数据
  goodsInfoEdit(id)
  {
    detailInfo(id).then(res => {
      this.formInfo = res.data
      this.uploadList.push({
        'url': this.formInfo.pic,
        'showProgress': false,
        'percentage': 100,
        'status': 'finished'
      })//  缩略图
    }).catch(res => {
      this.$Message.error(res.msg)
    })
  }
  ,
  }
  }
</script>
